export const OriginType = {
  CHANNEL_MANAGER: 'CHANNEL_MANAGER',
  BOOKING_ENGINE: 'BOOKING_ENGINE',
} as const;

export type OriginType = typeof OriginType[keyof typeof OriginType];
